export default "/assets/images/hi-mila-black.13c0f821f7b63eeb.webp";